import React from "react";
import WideContainer from "../../components/WideContainer";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import ScheduleIcon from "@mui/icons-material/Schedule";
import GetAppIcon from "@mui/icons-material/GetApp";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckIcon from "@mui/icons-material/Check";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import TextField from "@mui/material/TextField";
import DialogTitle from "@mui/material/DialogTitle";
import Snackbar from "@mui/material/Snackbar";
import Alert from '@mui/material/Alert';
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Checkbox from "@mui/material/Checkbox";
import Select from "@mui/material/Select";
import ListSubheader from '@mui/material/ListSubheader';
import CircularProgress from "@mui/material/CircularProgress";
import TrendingFlatIcon from "@mui/icons-material/TrendingFlat";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Link } from "react-router-dom";
import {
  Player,
  ControlBar,
  BigPlayButton,
  LoadingSpinner,
  PlayToggle,
  VolumeMenuButton,
  FullscreenToggle,
  CurrentTimeDisplay,
  TimeDivider,
  DurationDisplay,
  ProgressControl,
} from "video-react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { VariableSizeList as List } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";
import { Trans, withTranslation } from "react-i18next";

import "../../../node_modules/video-react/dist/video-react.css";
import axios from "../../components/Axios";
import "./Queries.css";

class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loading_items: false,
      loaded_video: false,
      items: [{ video_name: "Source video" }],
      source: 0,
      sourceDialogAnchor: null,
      segments: [],
      selected: new Set([]),
      sentences: [],
      characters: {},
      player: {
        duration: 0,
      },
      playerSource: undefined,
      extractDialog: false,
      extractSuccessDialog: false,
      extractName: "",
      extractRatio: "0:0",
      extractFrame: true,
      extractPadding: 0,
      disableRatio: false,
    };

    this.sentenceListRef = React.createRef();
    this.tvideo = React.createRef();

    this.handleChange = this.handleChange.bind(this);
    this.seekThumbnails = this.seekThumbnails.bind(this);
    this.getThumbnail = this.getThumbnail.bind(this);
    this.goBack = this.goBack.bind(this);

    this.seek_time = 0;
  }

  componentDidMount() {
    // subscribe state change
    this.player.subscribeToStateChange(this.handleStateChange.bind(this));

    this.setState({
      loading: true,
      // the query's result, saved by the Queries tab; none when the page is opened directly
      segments:
        JSON.parse(
          localStorage.getItem(
            "project/" + this.props.project.project_id + "/query_search"
          )
        ) || [],
    });

    let q = JSON.parse(
      localStorage.getItem(
        "project/" + this.props.project.project_id + "/query"
      )
    );
    /*
    if (q !== null && q['query_criterions_list'].length == 1 && q['query_criterions_list'][0]['inclusion'] == true) {
      if (q['query_criterions_list'][0]['char_id'] >= 0) {
        this.setState({ disableRatio: false });
      }
    }*/

    axios
      .get(
        "/video_project/" +
        this.props.project.project_id +
        "/videos?video_type=LOW_RESOLUTION"
      )
      .then(
        function (response) {
          response.data[0].video_name = "Source video";
          this.setState({
            loading: false,
            items: response.data,
          });

          if (this.state.source in response.data) {
            this.setState({
              playerSource: response.data[this.state.source].video_path,
            });
          }
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log(error);
          this.setState({ loading: false });
        }.bind(this)
      );
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.playerSource !== prevState.playerSource) {
      this.player.load();
      //refresh segments thumbnails
    }

    if (this.state.player.currentTime !== prevState.player.currentTime) {
      for (var i in this.props.sentences.items) {
        //scroll to sentence
        if (
          this.state.player.currentTime < this.props.sentences.items[i].end_time
        ) {
          let t = i - 1;
          if (t < 0) t = 0;
          this.sentenceListRef.current.scrollToItem(i, "center");
          break;
        }
      }
    }
  }

  handleStateChange(state) {
    // copy player state to this component's state
    this.setState({
      player: state,
    });
  }

  handleChange(v, e) {
    this.setState({ [v.target.name]: v.target.value });

    //set padding to 0 if not original ratio
    if (v.target.name == 'extractRatio' && v.target.value != '0:0') {
      this.setState({ extractPadding: 0 });
    }
  }
  checkboxChange(v, e) {
    this.setState({ [v.target.name]: v.target.checked });
  }

  formatDuration(s) {
    if (Number.isNaN(s)) return "0:00";

    let pad = function (num, size) {
      return ("000" + num).slice(size * -1);
    },
      time = parseFloat(s).toFixed(3),
      hours = Math.floor(time / 60 / 60),
      minutes = Math.floor(time / 60) % 60,
      seconds = Math.floor(time - minutes * 60);
    if (hours > 0) return hours + ":" + pad(minutes, 2) + ":" + pad(seconds, 2);
    else return minutes + ":" + pad(seconds, 2);
  }

  seekVideo(t) {
    this.player.seek(t);
  }

  seekThumbnails(e) {
    this.setState({ loaded_video: true });

    let q = this.state.segments.filter((i) => {
      return !("src" in i);
    });

    if (q.length > 0) {
      this.seek_time = q[0]["start_time"];
      this.tvideo.current.currentTime = this.seek_time;
    }
  }

  getThumbnail(e) {
    let canvas = document.createElement("canvas");
    canvas.width = this.tvideo.current.videoWidth;
    canvas.height = this.tvideo.current.videoHeight;
    let context = canvas.getContext("2d");
    context.drawImage(this.tvideo.current, 0, 0, canvas.width, canvas.height);
    let dataURI = canvas.toDataURL("image/jpeg");
    let t = this.seek_time;

    //set thumbnail then seek another thumbnail
    this.setState(
      function (state) {
        for (let i in state.segments) {
          if (state.segments[i].start_time === t) {
            state.segments[i].src = dataURI;
            break;
          }
        }
        return state;
      },
      function () {
        this.seekThumbnails(null);
      }
    );
  }

  getThumbnailStyle(s) {
    if ("src" in s) return { backgroundImage: "url(" + s.src + ")" };
    return {};
  }

  getTimelineStyle(s, d) {
    let w = ((s.end_time - s.start_time) / d) * 100;
    let l = (s.start_time / d) * 100;

    return { left: l + "%", width: w + "%" };
  }

  getVideoRatio(w, h) {
    let p = (h / w) * 100;
    if (isNaN(p)) p = 56.25;
    return p + "%";
  }

  isHighlight(s, r) {
    for (var i in r) {
      if (
        (r[i].start_time < s.start_time && s.start_time < r[i].end_time) ||
        (r[i].start_time < s.end_time && s.end_time < r[i].end_time)
      ) {
        return "true";
      }
    }
    return "false";
  }

  selectItem(i, e) {
    e.stopPropagation();
    //this.seekVideo(s.start_time);

    let has = this.state.selected.has(i);
    this.setState(function (state) {
      if (has) {
        state.selected.delete(i);
      } else {
        state.selected.add(i);
      }
      return state;
    });
  }

  extractDialog(i, e) {
    e.stopPropagation();
    if (i !== null) {
      this.setState(function (state) {
        state.selected.add(i);
        state.extractName = "Clip " + i;
        return state;
      });
    }

    this.setState({ extractDialog: true });
    if (this.state.extractName === "")
      this.setState({
        extractName: "Clip " + [...this.state.selected].join(","),
      });
  }

  closeExtractDialog() {
    this.setState({ extractDialog: false });
  }

  extractJob() {
    let d = {
      project_id: this.state.items[this.state.source].project_id,
      source_video_id: this.state.items[this.state.source].video_id,
      video_name: this.state.extractName,
      aspect_ratio: this.state.extractRatio,
      query: JSON.parse(
        localStorage.getItem(
          "project/" + this.props.project.project_id + "/query"
        )
      ),
      time_segments_list: [],
      padding_time: parseInt(this.state.extractPadding),
    };
    for (let i of this.state.selected)
      d.time_segments_list.push({
        start_time: this.state.segments[i].start_time,
        end_time: this.state.segments[i].end_time,
      });

    this.setState({ extractSuccessDialog: true, extractDialog: false });
    axios
      .post("/dispatch_jobs/extraction", d)
      .then(
        function (response) {
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log(error);
          //this.setState({ loading: false });
        }.bind(this)
      );
  }

  closeExtractSuccessDialog() {
    this.setState({ extractSuccessDialog: false });
  }

  openSourceMenu(e) {
    this.setState({ sourceDialogAnchor: e.target, loading_items: true });
    axios
      .get(
        "/video_project/" +
        this.props.project.project_id +
        "/videos?video_type=REDACTION"
      )
      .then(
        function (response) {
          response.data.unshift(this.state.items[0]);
          this.setState({
            loading_items: false,
            items: response.data.filter((i) => i.status === "PROCESSED"),
          });
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log(error);
          this.setState({ loading: false });
        }.bind(this)
      );
  }
  closeSourceMenu() {
    this.setState({ sourceDialogAnchor: null });
  }
  setSource(i) {
    if (this.state.source !== i) {
      //clear thumbnails
      this.setState(function (state) {
        for (let i in state.segments) {
          delete state.segments[i].src;
        }
        return state;
      });
    }

    //set source and video
    this.setState({
      sourceDialogAnchor: null,
      source: i,
      playerSource: this.state.items[i].video_path,
    });
  }

  goBack() {
    this.props.history.goBack();
  }

  getSentenceSize(index) {
    let l = Math.ceil(this.props.sentences.items[index].text.length / 55);
    return 32 + l * 21;
  }

  render() {
    return (
      <>
        <div className="topBar" style={{ zIndex: "1" }}>
          <WideContainer className="flex">
            <div
              className="mainColumn flex"
              style={{ borderRight: "1px solid #dfe7f0", height: "64px" }}
            >
              <div className="subjectText flex">
                {this.state.items[this.state.source].video_name + " "}
                <IconButton
                  onClick={this.openSourceMenu.bind(this)}
                  size="small"
                >
                  <ExpandMoreIcon style={{ fontSize: "16px" }} />
                </IconButton>
                <Menu
                  anchorEl={this.state.sourceDialogAnchor}
                  keepMounted
                  open={Boolean(this.state.sourceDialogAnchor)}
                  onClose={this.closeSourceMenu.bind(this)}
                  anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                  transformOrigin={{ vertical: "top", horizontal: "left" }}
                >
                  {this.state.items.map((i, k) => (
                    <MenuItem
                      onClick={this.setSource.bind(this, k)}
                      key={"smi" + k}
                      selected={k === this.state.source}
                    >
                      {i.video_name}
                      {k === this.state.source && <CheckIcon className="vv-menuCheck" />}
                    </MenuItem>
                  ))}
                  {this.state.loading_items && (
                    <div style={{ textAlign: "center" }}>
                      <CircularProgress size={20} />
                    </div>
                  )}
                </Menu>
              </div>
              <div className="timeArea flex">
                <ScheduleIcon style={{ color: "#90a7c6", fontSize: "18px" }} />
                <div
                  className="timeDiv flex"
                  style={{ borderLeft: "1px solid #c9d9ef" }}
                >
                  {this.formatDuration(this.state.player.duration)}
                </div>
              </div>
            </div>
            <div className="sideColumn flex">
              <div
                className="subjectText flex"
                style={{ margin: "0 8px 0 24px" }}
              >
                <Trans>Query Results</Trans>
                <IconButton
                  hidden
                  size="small"
                >
                  <ExpandMoreIcon style={{ fontSize: "16px" }} />
                </IconButton>
              </div>
              <div>
                <IconButton
                  onClick={this.goBack}
                  size="small"
                  style={{
                    position: "relative",
                    left: "20px",
                    color: "#1355b2",
                  }}
                >
                  <TrendingFlatIcon style={{ transform: "rotate(180deg)" }} />
                </IconButton>
                <Button className="Button" size="small" onClick={this.goBack}>
                  <Trans>Back</Trans>
                </Button>
              </div>
            </div>
          </WideContainer>
        </div>
        <WideContainer
          className="flex"
          style={{ alignItems: "start" }}
        >
          <div
            className="mainColumn topBar bodyContent"
            style={{ height: "calc(100vh - 156px)" }}
          >
            <Player
              ref={(player) => {
                this.player = player;
              }}
              autoPlay={false}
              preload="auto"
              src={this.state.playerSource}
            >
              <LoadingSpinner />
              <BigPlayButton position="center" />
              <ControlBar autoHide={false} disableDefaultControls>
                <PlayToggle key="play-toggle" order={1} />
                <VolumeMenuButton key="volume-menu-button" order={4} vertical />
                <CurrentTimeDisplay key="current-time-display" order={5.1} />
                <DurationDisplay key="duration-display" order={7.3} />
                <ProgressControl key="progress-control" order={6} />
                <FullscreenToggle key="fullscreen-toggle" order={8} />
              </ControlBar>
            </Player>
            <div
              className="timelineHighlights"
              hidden={!this.state.player.hasStarted}
            >
              {this.state.segments.map((s, i) => (
                <div
                  key={"highlight" + i}
                  className="timelineHighlight"
                  style={this.getTimelineStyle(s, this.state.player.duration)}
                />
              ))}
            </div>
            <div className="transcriptBox" style={{ padding: "0", flex: "1" }}>
              <AutoSizer>
                {({ height, width }) => (
                  <List
                    ref={this.sentenceListRef}
                    height={height}
                    width={width}
                    itemCount={this.props.sentences.items.length}
                    itemSize={this.getSentenceSize.bind(this)}
                    overscanCount={4}
                  >
                    {({ index, style }) => (
                      <div
                        className="transcriptSegmentV"
                        data-highlight={this.isHighlight(
                          this.props.sentences.items[index],
                          this.state.segments
                        )}
                        style={style}
                        onClick={this.seekVideo.bind(
                          this,
                          this.props.sentences.items[index].start_time
                        )}
                      >
                        <div className="subjectText transcriptTime">
                          {this.formatDuration(
                            this.props.sentences.items[index].start_time
                          )}
                        </div>
                        <div className="subjectText transcriptSubject">
                          {
                            this.props.characters.dic[
                            this.props.sentences.items[index].char_id
                            ]
                          }
                        </div>
                        <div className="subjectSpeech transcriptSpeech">
                          {this.props.sentences.items[index].text}
                        </div>
                      </div>
                    )}
                  </List>
                )}
              </AutoSizer>
            </div>
          </div>
          <div
            className="sideColumn extractArea bodyContent"
            style={{ height: "calc(100vh - 156px)" }}
          >
            <div className="flex" style={{ padding: "20px 4px 8px 32px" }}>
              <div className="subjectSpeech">
                <b className="subjectText">{this.state.segments.length}</b>{" "}
                <Trans>segments found</Trans>
              </div>
              <Button disabled
                className="Button"
                size="small"
                onClick={this.extractDialog.bind(this, null)}
                endIcon={<GetAppIcon style={{ color: "#1355b2" }} />}
              >
                <Trans>Extract</Trans>
              </Button>
            </div>
            <div className="thumbnailArea">
              {this.state.segments.map((s, i) => (
                <div
                  key={"segment" + i}
                  className="thumbnailDiv"
                  data-selected={this.state.selected.has(i)}
                  style={this.getThumbnailStyle(s)}
                  onClick={this.seekVideo.bind(this, s.start_time)}
                >
                  <div
                    style={{
                      paddingTop: this.getVideoRatio(
                        this.state.player.videoWidth,
                        this.state.player.videoHeight
                      ),
                    }}
                  >
                    <div className="thumbnailTime">
                      {this.formatDuration(s.start_time) +
                        " - " +
                        this.formatDuration(s.end_time)}
                    </div>
                  </div>
                  <div
                    className="imgBtn"
                    style={{ top: "4px", right: "4px" }}
                    onClick={this.extractDialog.bind(this, i)}
                  >
                    <GetAppIcon fontSize="small" />
                  </div>
                  <div
                    className="clipCheckbox"
                    onClick={this.selectItem.bind(this, i)}
                  >
                    <div className="clipCheckboxBg"></div>
                    <Checkbox
                      color="primary"
                      checked={this.state.selected.has(i)}
                    />
                  </div>
                </div>
              ))}
              <div className="thumbnailDiv" style={{ opacity: 0 }}></div>
            </div>
          </div>
        </WideContainer>
        <video
          hidden
          ref={this.tvideo}
          crossOrigin="use-credentials"
          src={this.state.playerSource}
          onLoadedData={this.seekThumbnails}
          onSeeked={this.getThumbnail}
        />
        <Dialog
          open={this.state.extractDialog}
          scroll="paper"
          onClose={this.closeExtractDialog.bind(this)}
        >
          <DialogTitle>
            <div
              className="charNameTitle"
              style={{ padding: "16px 8px 0 8px" }}
              id="draggable-dialog-title"
            >
              <Trans>Extract as clip</Trans>
            </div>
          </DialogTitle>
          <DialogContent>
            <div style={{ width: "490px", display: "flex", padding: "0 8px" }}>
              <div style={{ flex: "1" }}>
                <label
                  htmlFor="extractName"
                  style={{ color: "#063e6c", fontWeight: "bold" }}
                >
                  <Trans>Extract Name</Trans>
                </label>
                <br />
                <TextField
                  name="extractName"
                  id="extractName"
                  variant="outlined"
                  size="small"
                  value={this.state.extractName}
                  onChange={this.handleChange}
                  type="text"
                  fullWidth
                />
              </div>
            </div>
            <div style={{ width: "490px", display: "flex", padding: "8px 8px 0" }}>
              <div style={{ width: '140px' }}>
                <label
                  htmlFor="aspect_ratio" title='Resize video to this aspect ratio and crop intelligently, available only if one character is queried'
                  style={{ color: "#063e6c", fontWeight: "bold" }}
                >
                  <Trans>Aspect Ratio</Trans>
                </label>
                <br />
                <Select
                  name="extractRatio"
                  value={this.state.extractRatio}
                  variant="outlined"
                  className="conditionField"
                  style={{ borderRadius: '4px' }}
                  onChange={this.handleChange}
                  fullWidth disabled={this.state.disableRatio}
                >
                  <MenuItem value={'0:0'}><Trans>Original</Trans></MenuItem>
                  <ListSubheader><Trans>Landscape</Trans> (16:9)</ListSubheader>
                  <MenuItem value={'16:9:yt'}>Youtube</MenuItem>
                  <MenuItem value={'16:9:li'}>LinkedIn</MenuItem>
                  <MenuItem value={'16:9:fb'}>Facebook</MenuItem>
                  <MenuItem value={'16:9:tw'}>Twitter</MenuItem>
                  <ListSubheader><Trans>Portrait</Trans> (9:16)</ListSubheader>
                  <MenuItem value={'9:16:tt'}>Tiktok</MenuItem>
                  <MenuItem value={'9:16:ig'}>Instagram</MenuItem>
                  <MenuItem value={'9:16:fb'}>Facebook</MenuItem>
                  <MenuItem value={'9:16:li'}>LinkedIn</MenuItem>
                  <MenuItem value={'9:16:tw'}>Twitter</MenuItem>
                  <MenuItem value={'9:16:pt'}>Pinterest</MenuItem>
                  <MenuItem value={'9:16:sc'}>Snapchat</MenuItem>
                  <ListSubheader><Trans>Square</Trans> (1:1)</ListSubheader>
                  <MenuItem value={'1:1:ig'}>Instagram</MenuItem>
                  <MenuItem value={'1:1:tw'}>Twitter</MenuItem>
                  <MenuItem value={'1:1:li'}>LinkedIn</MenuItem>
                  <MenuItem value={'1:1:pt'}>Pinterest</MenuItem>
                </Select>
              </div>
              <div style={{ width: "80px", marginLeft: "16px" }}>
                <label
                  htmlFor="extractPadding" title="Number of seconds to add before and after the clip"
                  style={{ color: "#063e6c", fontWeight: "bold" }}
                >
                  <Trans>Padding</Trans>
                </label>
                <br />
                <TextField
                  name="extractPadding"
                  id="extractPadding"
                  variant="outlined"
                  size="small"
                  value={this.state.extractPadding}
                  onChange={this.handleChange}
                  type="number"
                  fullWidth
                />
              </div>
              <div style={{ flex: "1" }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.extractFrame}
                      color="primary"
                      className="CheckBox"
                      size="small"
                      name="extractFrame"
                      onChange={this.checkboxChange.bind(this)}
                    />
                  }
                  style={{ marginLeft: "-2px", position: 'relative', top: '16px' }}
                  label={<Trans>Download best frame</Trans>}
                  className="checkboxLabel"
                />
              </div>
            </div>
            <div className="segments-selected">
              <b>{this.state.selected.size}</b> <Trans>segments selected</Trans>
            </div>
            <div className="extractDialogClips">
              {[...this.state.selected].map((i) => (
                <div
                  key={"clip" + i}
                  className="thumbnailDiv"
                  style={this.getThumbnailStyle(this.state.segments[i])}
                >
                  <div
                    style={{
                      paddingTop: this.getVideoRatio(
                        this.state.player.videoWidth,
                        this.state.player.videoHeight
                      ),
                    }}
                  >
                    <div className="thumbnailTime">
                      {this.formatDuration(this.state.segments[i].start_time) +
                        " - " +
                        this.formatDuration(this.state.segments[i].end_time)}
                    </div>
                  </div>
                </div>
              ))}
              <div
                className="thumbnailDiv"
                style={{ opacity: 0, margin: 0, height: 0 }}
              ></div>
            </div>

          </DialogContent>
          <DialogActions>
            <Button
              autoFocus
              onClick={this.closeExtractDialog.bind(this)}
              color="primary"
            >
              <Trans>Cancel</Trans>
            </Button>
            <Button
              onClick={this.extractJob.bind(this)}
              color="primary"
              disabled={this.state.selected.size === 0}
            >
              <Trans>Extract</Trans>
            </Button>
          </DialogActions>
        </Dialog>
        <Snackbar open={this.state.extractSuccessDialog}>
          <Alert
            elevation={6}
            variant="filled"
            onClose={this.closeExtractSuccessDialog.bind(this)}
            severity="success"
          >
            <span>
              <Trans>Extraction job started</Trans>.{" "}
              <Link
                to="clips"
                style={{ color: "inherit", textDecoration: "underline" }}
              >
                <Trans>View Clips</Trans>
              </Link>
            </span>
          </Alert>
        </Snackbar>
      </>
    );
  }
}

const mapState = (state) => {
  return {
    sentences: state.sentences,
    characters: state.characters,
  };
};
export default withTranslation()(withRouter(connect(mapState)(Index)));
